import { useMutation, useQueryClient } from '@tanstack/react-query';

/* Keys & Apis */
import { speedTest } from '@api/apis';
import { speedTestQueryKeys } from './queries.keys';

/* Utils */
import { Logger } from '@utils/logger';

type SpeedTestProps = {
  ping: number;
  jitter: number;
  upload: number;
  download: number;
};

export default function useSpeedMutationSendData() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (results: SpeedTestProps) => {
      /* send data to BE */
      const data = await speedTest.sendResults({ results });
      if (data.status === 500) throw new Error(data.err);
      return data;
    },
    onSuccess: data => {
      const { speedTest: response = {} } = data?.data ?? {};
      queryClient.setQueryData(speedTestQueryKeys.sendResults, { ...response });
    },
    onError: error => {
      Logger('useSpeedMutationSendData')(error as Error);
    },
  });
}
